import { JOHN_DEERE_TAG_PREFIX, JOHN_DEERE_TAG_SUFFIX } from 'utils/johnDeereTag/constants';

import { DEMO_HIDE_TAGS } from './constants';
import type { DemoFilterable } from './types';

const HIDDEN_NAME_FRAGMENTS = DEMO_HIDE_TAGS.map(
    tag => `${JOHN_DEERE_TAG_PREFIX}${tag.replace(/^JD-/, '')}${JOHN_DEERE_TAG_SUFFIX}`
);

export const isDemoHideModeEnabled = (): boolean =>
    import.meta.env.VITE_HIDE_DEMO_RECORDS === 'true';

export const isDemoHiddenName = (name: string): boolean =>
    HIDDEN_NAME_FRAGMENTS.some(fragment => name.includes(fragment));

export const filterDemoRecords = <T extends DemoFilterable>(items: T[]): T[] => {
    if (!isDemoHideModeEnabled()) {
        return items;
    }

    return items.filter(item => !isDemoHiddenName(item.name));
};
